import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { useNativeBridgeActions } from '#pplx/frontend/apps/ask/native-bridges/store.js';
import { usePerplexityQueryState } from '#pplx/frontend/apps/ask/providers/ask-query-state-provider/hooks/usePerplexityQueryState.js';
import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { getUpsellModalOrigin } from '#pplx/frontend/apps/ask/upsell-slots/action-runtime/getUpsellModalOrigin.js';
import { useGetStripePromise } from '#pplx/frontend/billing/stripe-browser/useStripePromise.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
export const useUpsellActionBaseRuntime = ({ executeCtaHandler, hideUpsell, upsellInformation, }) => {
    const { track, impression } = useInstrumentation();
    const { firstResult, lastResult } = useResults();
    const { openModal } = useModalContext();
    const queryClient = useQueryClient();
    const getStripePromise = useGetStripePromise();
    const { submitQuery } = usePerplexityQueryState();
    const router = useRouter();
    const { openToast } = useToastContext();
    const { openBrowserExtensionInstall } = useNativeBridgeActions();
    const { $t } = useIntl();
    const origin = getUpsellModalOrigin(upsellInformation);
    const retryQueryParam = `?handle_upsell=true`;
    return useMemo(() => ({
        $t,
        executeCtaHandler,
        firstResult,
        hideUpsell,
        lastResult,
        openModal,
        openBrowserExtensionInstall,
        openToast,
        origin,
        queryClient,
        getStripePromise,
        retryQueryParam,
        router: { push: router.push },
        submitQuery,
        track,
        impression,
    }), [
        $t,
        executeCtaHandler,
        firstResult,
        hideUpsell,
        lastResult,
        openModal,
        openBrowserExtensionInstall,
        openToast,
        origin,
        queryClient,
        getStripePromise,
        retryQueryParam,
        router.push,
        submitQuery,
        track,
        impression,
    ]);
};
//# sourceMappingURL=useUpsellActionBaseRuntime.js.map